import {Callout, CalloutType} from "./Callout";

export default Callout;
export {Callout, CalloutType};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Callout/index.tsx